
document.addEventListener('DOMContentLoaded', function() {
  'use strict';

  /* ── FAQ accordion ── */
  var faqBtns = document.querySelectorAll('.tro-aff-faq-q');
  faqBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var wasOpen = this.classList.contains('open');
      faqBtns.forEach(function(b) { b.classList.remove('open'); });
      if (!wasOpen) this.classList.add('open');
    });
  });

  /* ── Smooth scroll for anchor links ── */
  document.querySelectorAll('.tro-aff a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ── Form submission ── */
  var form = document.getElementById('tro-aff-form');
  if (!form) return;

  form.addEventListener('submit', function(e) {
    e.preventDefault();

    var btn = document.getElementById('aff-submit-btn');
    btn.disabled = true;
    btn.textContent = 'Submitting…';

    var fname = document.getElementById('aff-fname').value.trim();
    var lname = document.getElementById('aff-lname').value.trim();
    var email = document.getElementById('aff-email').value.trim();
    var phone = document.getElementById('aff-phone').value.trim();
    var platform = document.getElementById('aff-platform').value;
    var audience = document.getElementById('aff-audience').value;
    var niche = document.getElementById('aff-niche').value;
    var social = document.getElementById('aff-social').value.trim();
    var why = document.getElementById('aff-why').value.trim();

    /* ── 1. Subscribe to Klaviyo list ── */
    var klaviyoPayload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Affiliate Program Application',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                first_name: fname,
                last_name: lname,
                phone_number: phone || undefined,
                properties: {
                  'Affiliate Platform': platform,
                  'Affiliate Audience Size': audience,
                  'Affiliate Niche': niche,
                  'Affiliate Social URL': social,
                  'Affiliate Interest': why,
                  'Source': 'Affiliate Application Form'
                }
              }
            }
          }
        }
      }
    };

    /* 
       Klaviyo Subscribe API (client-side)
       Uses the Klaviyo onsite JS already loaded by Shopify.
       This subscribes the user to your main marketing list.
       
       IMPORTANT: Replace YOUR_KLAVIYO_LIST_ID below with your actual
       Klaviyo list ID. To find it:
       1. Go to Klaviyo > Audience > Lists & Segments
       2. Click your marketing list
       3. The list ID is in the URL: https://www.klaviyo.com/list/XXXXXX
    */
    var KLAVIYO_LIST_ID = 'YOUR_KLAVIYO_LIST_ID'; /* <-- REPLACE THIS */
    var KLAVIYO_COMPANY_ID = ''; /* Auto-detected from Shopify Klaviyo integration */

    /* Attempt to get company ID from existing Klaviyo script */
    try {
      var klScripts = document.querySelectorAll('script[src*="klaviyo"]');
      klScripts.forEach(function(s) {
        var match = s.src.match(/company_id=([A-Za-z0-9]+)/);
        if (match) KLAVIYO_COMPANY_ID = match[1];
      });
    } catch(e) {}

    /* Use Klaviyo client API if available */
    if (window.klaviyo && typeof window.klaviyo.push === 'function') {
      window.klaviyo.push(['identify', {
        email: email,
        first_name: fname,
        last_name: lname,
        phone_number: phone || undefined,
        'Affiliate Platform': platform,
        'Affiliate Audience Size': audience,
        'Affiliate Niche': niche,
        'Affiliate Social URL': social,
        'Source': 'Affiliate Application Form'
      }]);
    }

    /* Klaviyo Subscribe API v3 (client-side) */
    if (KLAVIYO_COMPANY_ID) {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Affiliate Program Application',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    first_name: fname,
                    last_name: lname,
                    phone_number: phone || undefined,
                    properties: {
                      'Affiliate Platform': platform,
                      'Affiliate Audience Size': audience,
                      'Affiliate Niche': niche,
                      'Affiliate Social URL': social,
                      'Affiliate Interest': why,
                      'Source': 'Affiliate Application Form'
                    }
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: KLAVIYO_LIST_ID
                }
              }
            }
          }
        })
      }).catch(function() { /* Silently handle — email notification is primary */ });
    }

    /* ── 2. Send notification email to Sales@therecoveryoutlet.com ── */
    /* 
       Uses Shopify's built-in contact form endpoint to send the email.
       This sends to the store's customer email (which should be or forward to
       Sales@therecoveryoutlet.com). 
       
       Alternative: If you want to guarantee delivery to Sales@therecoveryoutlet.com,
       set up a Klaviyo flow triggered by the "Affiliate Application Form" source
       that sends an internal notification email.
    */
    var formData = new FormData();
    formData.append('form_type', 'contact');
    formData.append('utf8', '✓');
    formData.append('contact[email]', email);
    formData.append('contact[first_name]', fname);
    formData.append('contact[last_name]', lname);
    formData.append('contact[phone]', phone);
    formData.append('contact[body]',
      '--- NEW AFFILIATE APPLICATION ---\n\n' +
      'Name: ' + fname + ' ' + lname + '\n' +
      'Email: ' + email + '\n' +
      'Phone: ' + (phone || 'Not provided') + '\n' +
      'Primary Platform: ' + platform + '\n' +
      'Audience Size: ' + audience + '\n' +
      'Content Niche: ' + niche + '\n' +
      'Social/Website: ' + (social || 'Not provided') + '\n' +
      'Why TRO: ' + (why || 'Not provided') + '\n\n' +
      '--- Submitted from Affiliate Program page ---'
    );
    formData.append('contact[tags]', 'affiliate-application');

    fetch('/contact#contact_form', {
      method: 'POST',
      body: formData
    })
    .then(function() {
      /* Show success state */
      document.getElementById('tro-aff-form-wrap').style.display = 'none';
      document.getElementById('tro-aff-success').style.display = 'block';
    })
    .catch(function() {
      /* Still show success — Klaviyo captured the data */
      document.getElementById('tro-aff-form-wrap').style.display = 'none';
      document.getElementById('tro-aff-success').style.display = 'block';
    });
  });
});
